import type { AddSDDMandatBodyType } from '~/types';

export const useWalletSDDMandatStore = defineStore('wallet-sdd-mandat', {
  state: () => ({
    holder: {
      value: '' as string | undefined,
      isValid: undefined as boolean | undefined
    },
    iban: {
      value: '' as string | undefined,
      isValid: undefined as boolean | undefined
    },
    bic: {
      value: '' as string | undefined,
      isValid: undefined as boolean | undefined
    },
    street: {
      value: '' as string | undefined,
      isValid: undefined as boolean | undefined
    },
    postCode: {
      value: '' as string | undefined,
      isValid: undefined as boolean | undefined
    },
    city: {
      value: '' as string | undefined,
      isValid: undefined as boolean | undefined
    },
    country: undefined as string | undefined,
    mandatLanguage: 'fr' as string | undefined,
    umr: {
      value: '' as string | undefined,
      isValid: undefined as boolean | undefined
    },
    password: {
      value: '' as string | undefined,
      isValid: undefined as boolean | undefined
    },
    language: undefined as string | undefined,
    wallet: undefined as string | undefined,
    IsRecurring: false as boolean,
    IsB2B: false as boolean,
    openAddSddMandateModal: false as Boolean,
    openDisableSddMandateModal: false as Boolean,
    openRequestDebitModal: false as Boolean,
    addSDDMandatStep: 0 as number
  }),
  getters: {
    getAddSDDmandatBody(): AddSDDMandatBodyType {
      return {
        Holder: this.holder.value,
        Iban: this.iban.value,
        Bic: this.bic.value,
        IsRecurring: this.IsRecurring,
        IsB2B: this.IsB2B,
        Street: this.street.value,
        PostCode: this.postCode.value,
        City: this.city.value,
        country: this.country,
        MandateLanguage: this.mandatLanguage,
        Rum: this.umr.value,
        Password: this.password.value,
        language: this.language,
        Wallet: this.wallet
      };
    }
  },
  actions: {
    init() {
      this.holder = { value: '', isValid: undefined };
      this.iban = { value: '', isValid: undefined };
      this.bic = { value: '', isValid: undefined };
      this.street = { value: '', isValid: undefined };
      this.postCode = { value: '', isValid: undefined };
      this.city = { value: '', isValid: undefined };
      this.country = '';
      this.mandatLanguage = 'fr';
      this.umr = { value: '', isValid: undefined };
      this.password = { value: '', isValid: undefined };
      this.addSDDMandatStep = 0;
      this.IsB2B = false;
      this.IsRecurring = false;
    }
  }
});
